// File written after watching this video: https://www.youtube.com/watch?v=Ap_csCnTSA4&list=PL-LRDpVN2fZCZdGt6N2g7Ykl0lRFXFE7H&index=4

//Below function copied from: https://gist.github.com/stewartknapman/8d8733ea58d2314c373e94114472d44c
//Function used to format the price with the shop's currency configuraion.
function formatMoney(cents, format) {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  let value = "";
  // This regex finds {{amount}}, {{amount_no_decimals}}, etc.
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || "${{amount}}";

  function formatWithDelimiters(
    number,
    precision = 2,
    thousands = ",",
    decimal = "."
  ) {
    if (isNaN(number) || number == null) return "0";
    number = (number / 100.0).toFixed(precision);

    const parts = number.split(".");
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d{3})+(?!\d))/g,
      "$1" + thousands
    );
    const centsAmount = parts[1] ? decimal + parts[1] : "";

    return dollarsAmount + centsAmount;
  }

  const match = formatString.match(placeholderRegex);
  if (!match) return formatString; // Return as is if no placeholder found

  switch (match[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    default:
      value = formatWithDelimiters(cents, 2);
  }

  // This replaces ONLY the {{amount}} part, leaving 'USD' or other currency codes intact
  return formatString.replace(placeholderRegex, value);
}

function initCartDrawer() {
  // Per-key request counters: discard stale /cart/change.js responses when
  // the user clicks faster than responses arrive for the same row.
  const latestCartRequestId = {};

  function changeItemQuantity(key, quantity) {
    const row = document.querySelector(`[data-key="${key}"]`);
    if (row) row.setAttribute("data-updating", "true");

    latestCartRequestId[key] = (latestCartRequestId[key] || 0) + 1;
    const requestId = latestCartRequestId[key];

    axios
      .post("/cart/change.js", {
        id: key,
        quantity,
      })
      .then((res) => {
        if (requestId !== latestCartRequestId[key]) return;

        const updatedRow = document.querySelector(`[data-key="${key}"]`);
        if (updatedRow) updatedRow.removeAttribute("data-updating");

        const moneyFormat = document
          .querySelector(".cart")
          .getAttribute("data-money-format");

        //Update header cart count after item quantity update
        if (window.refreshHeaderCartCount) {
          window.refreshHeaderCartCount();
        }
        const totalDiscount = formatMoney(res.data.total_discount, moneyFormat);
        const totalPrice = formatMoney(res.data.total_price, moneyFormat);
        const item = res.data.items.find((item) => item.key === key);
        const itemPrice = formatMoney(item.final_line_price, moneyFormat);

        document.querySelector("#total-discount").textContent = totalDiscount;
        document.querySelector("#total-price").textContent = totalPrice;
        if (item) {
          const itemPrice = formatMoney(item.final_line_price, moneyFormat);
          document.querySelector(
            `[data-key="${key}"] .line-item-price`
          ).textContent = itemPrice;

          // SYNC DATA-QTY: Important for inventory logic!
          const row = document.querySelector(`[data-key="${key}"]`);
          if (row) row.setAttribute("data-qty", item.quantity);
        }
      });
  }

  document
    .querySelectorAll(".cart-quantity-selector button")
    .forEach((button) => {
      button.addEventListener("click", () => {
        const cartItem = button.closest(".cart-item");
        const input = cartItem.querySelector("input");
        const plusBtn = cartItem.querySelector(".plus");

        const value = Number(input.value);
        const key = cartItem.getAttribute("data-key");
        const invManagement = cartItem.getAttribute(
          "data-inventory-management"
        );
        const invPolicy = cartItem.getAttribute("data-inventory-policy");
        const invVariantQty = Number(
          cartItem.getAttribute("data-inventory-quantity")
        );
        const isPlus = button.classList.contains("plus");
        console.log(value, invManagement, invPolicy, invVariantQty);
        if (isPlus) {
          // 1. Check if we are already at or above the limit
          if (
            invManagement === "shopify" &&
            invPolicy === "deny" &&
            value >= invVariantQty
          ) {
            // Just a safety return in case CSS 'pointer-events: none' is bypassed
            return;
          }

          const newValue = value + 1;
          input.value = newValue;

          // 2. Update the UI state immediately after incrementing
          if (
            invManagement === "shopify" &&
            invPolicy === "deny" &&
            newValue >= invVariantQty
          ) {
            plusBtn.classList.add("disabled-button");
            plusBtn.setAttribute("title", "No more stock available");
          }

          changeItemQuantity(key, newValue);
        } else if (value > 1) {
          const newValue = value - 1;
          input.value = newValue;

          // 3. Always re-enable the plus button when decreasing
          plusBtn.classList.remove("disabled-button");
          plusBtn.removeAttribute("title");

          changeItemQuantity(key, newValue);
        }
      });
    });

  document.querySelectorAll(".remove-item").forEach((remove) => {
    remove.addEventListener("click", (e) => {
      e.preventDefault();

      const item = remove.closest(".cart-item");
      const key = item.getAttribute("data-key");
      item.setAttribute("data-updating", "true");

      axios
        .post("/cart/change.js", {
          id: key,
          quantity: 0,
        })
        .then((res) => {
          item.removeAttribute("data-updating");

          //Update header cart count after item removal
          if (window.refreshHeaderCartCount) {
            window.refreshHeaderCartCount();
          }

          // 1. Get the money format for currency display
          const moneyFormat = document
            .querySelector(".cart")
            .getAttribute("data-money-format");

          if (res.data.items.length === 0) {
            // Handle Empty Cart state
            const cartContainer = document.querySelector(
              ".cart-drawer-content"
            );

            cartContainer.innerHTML = `<div class="drawer-header">
        <h2>0 Item(s) in your cart</h2>
        <div id="close-cart" aria-label="Close Cart">&times;</div>
      </div>
      <div class="drawer-body cart-empty">
        <p>Your cart is empty</p>
        <a class="button" href="/">Keep shopping</a>
      </div>`;

            document
              .getElementById("close-cart")
              .addEventListener("click", () => {
                document
                  .querySelector(".cart-drawer")
                  .classList.remove("cart-open");
                document
                  .querySelector(".cart-overlay")
                  .classList.remove("active");
              });
          } else {
            // 2. Remove the specific item from the DOM
            item.remove();

            // 3. Update the Totals in the Footer
            const totalPrice = formatMoney(res.data.total_price, moneyFormat);
            const totalDiscount = formatMoney(
              res.data.total_discount,
              moneyFormat
            );

            const totalPriceElement = document.querySelector("#total-price");
            const totalDiscountElement =
              document.querySelector("#total-discount");

            if (totalPriceElement) totalPriceElement.textContent = totalPrice;
            if (totalDiscountElement)
              totalDiscountElement.textContent = totalDiscount;
          }

          console.log("Item removed. New total:", res.data.total_price);
        })
        .catch((err) => {
          console.error("Failed to remove item:", err);
        });
    });
  });

  //Toggle side drawer

  const cartLinks = document.querySelectorAll(".cart-link");
  const cartDrawer = document.querySelector(".cart-drawer");
  const closeCartBtn = document.getElementById("close-cart");
  const cartOverlay = document.querySelector(".cart-overlay");

  function openCart() {
    cartDrawer.classList.add("cart-open");
    cartOverlay.classList.add("active");
  }

  function closeCart() {
    cartDrawer.classList.remove("cart-open");
    cartOverlay.classList.remove("active");
  }

  cartLinks.forEach((cartLink) => {
    cartLink.addEventListener("click", function (e) {
      e.preventDefault();
      openCart();
    });
  });

  closeCartBtn.addEventListener("click", closeCart);
  cartOverlay.addEventListener("click", closeCart);
}

document.addEventListener("DOMContentLoaded", function () {
  initCartDrawer();
});

window.initCartDrawer = initCartDrawer;
